import type { RouteObject } from 'react-router-dom';

import { AuthorizedOutlet } from '@myphx-engineering/auth/client';

import routes from '../app-routes';

import PlanSummaryRoute from './PlanSummaryRoute';

const planRoutes: RouteObject[] = [
    {
        path: routes.plan.root,
        element: <AuthorizedOutlet />,
        children: [
            {
                path: routes.plan.summary,
                element: <PlanSummaryRoute />,
            },
        ],
    },
];

export default planRoutes;
